import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Megaphone, Star } from "lucide-react";

export default function SpotlightBanner() {
    const [items, setItems] = useState([]);

    useEffect(() => {
        api.get("/featured").then((r) => setItems(r.data || [])).catch(() => setItems([]));
    }, []);

    if (!items.length) return null;

    const spotlight = items.find((i) => i.spotlight);
    const featured = items.filter((i) => i.featured && !i.spotlight).slice(0, 3);

    return (
        <div className="mb-6 space-y-3" data-testid="spotlight-block">
            {spotlight && (
                <Link
                    to={`/u/${spotlight.username}`}
                    className="brut-static bg-[#FFB8D1] rounded-xl px-4 py-4 flex items-center gap-3"
                    data-testid="spotlight-banner"
                >
                    <div className="w-11 h-11 rounded-lg bg-white border-2 border-[#0A0A0A] flex items-center justify-center shrink-0">
                        <Megaphone className="w-5 h-5" />
                    </div>
                    <div className="flex-1 min-w-0">
                        <div className="text-[10px] font-black uppercase tracking-widest text-[#0A0A0A]/70">Weekly Spotlight</div>
                        <div className="font-black text-base sm:text-lg leading-tight">@{spotlight.username}</div>
                        {spotlight.bio && <div className="text-xs font-medium text-[#0A0A0A]/70 truncate">{spotlight.bio}</div>}
                    </div>
                    <div className="text-xs font-bold uppercase text-[#0A0A0A]/70 shrink-0 hidden sm:block">View profile →</div>
                </Link>
            )}
            {featured.length > 0 && (
                <div className="brut-static bg-white rounded-xl p-4" data-testid="rising-pods">
                    <div className="flex items-center gap-1.5 text-[10px] font-black uppercase tracking-widest text-[#0A0A0A]/70 mb-2">
                        <Star className="w-3 h-3" /> Rising Pods
                    </div>
                    <div className="flex flex-wrap gap-2">
                        {featured.map((f) => (
                            <Link
                                key={f.username}
                                to={`/u/${f.username}`}
                                className="px-3 py-1.5 rounded-full brut-inset bg-[#B8E1FF] text-sm font-bold hover:bg-[#FFE55C]"
                                data-testid={`rising-pod-${f.username}`}
                            >
                                @{f.username}
                            </Link>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
